// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_CarregaDespesasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /despesas/carrega_despesas
 *
 * Returns a list of despesas (expenses) with aliased columns for display.
 * This is the xCRUD listing endpoint.
 *
 * Each item in the array contains:
 * - despesa_id: Expense ID
 * - franquia_id: Franchise ID (aliased from despesa_franquia_id)
 * - status: Translated status label
 * - despesa_status_id: Status ID
 * - categoria: Translated category label
 * - categoria_raw: Raw category title
 * - titulo: Expense title
 * - valor: Expense amount
 * - mensal: Monthly expense flag
 * - descricao: Description
 * - despesa_data_vencimento: Due date (DATE-only, ISO 8601 YYYY-MM-DD)
 * - despesa_data_lancamento: Creation timestamp (DATETIME, ISO 8601 UTC)
 * - data_vencimento: Formatted due date (display format)
 * - data_lancamento: Formatted creation timestamp (display format)
 * - parcela: Installment fraction e.g. "1/3"
 * - despesa_generated_from_payroll_id: Payroll period ID that generated this expense
 *
 * @see Despesas_Model::dadosXcrud() for the source query
 */
import type { Despesas_CarregaDespesasRow } from './Despesas_CarregaDespesasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_CarregaDespesasResponseDados = Despesas_CarregaDespesasRow[];

export type Despesas_CarregaDespesasResponse = ApiResponse<Despesas_CarregaDespesasResponseDados>;

registerResponseContract('Despesas_CarregaDespesasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      despesa_id:                        { type: 'number',  required: true },
      franquia_id:                       { type: 'number',  required: true },
      status:                            { type: 'string',  required: false },
      despesa_status_id:                 { type: 'number',  required: true },
      categoria:                         { type: 'string',  required: false },
      categoria_raw:                     { type: 'string',  required: true },
      titulo:                            { type: 'string',  required: true },
      valor:                             { type: 'number',  required: true },
      mensal:                            { type: 'number',  required: true },
      descricao:                         { type: 'string',  required: false },
      despesa_data_vencimento:           { type: 'string',  required: false },
      despesa_data_lancamento:           { type: 'string',  required: true },
      data_vencimento:                   { type: 'string',  required: false },
      data_lancamento:                   { type: 'string',  required: true },
      parcela:                           { type: 'string',  required: true },
      despesa_generated_from_payroll_id: { type: 'number',  required: false },
      franquia:                          { type: 'string',  required: false },
    },
  },
})
